import { Field } from 'redux-form';
import { TextField } from 'iqvia-shared/components';
import React from 'react';

const FloatObjectField = ({ name, label, onChange, readonlyForm }) => {
  const handleChange = event => {
    const {
      target: { value },
    } = event;

    if (value === '' || isNaN(Number(value))) {
      event.preventDefault();
      return;
    }

    onChange(value);
  };

  return (
    <Field
      name={`${name}`}
      component={TextField}
      type="number"
      label={label}
      disabled={readonlyForm}
      onChange={handleChange}
    />
  );
};

FloatObjectField.displayName = 'FloatObjectField';

export default FloatObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/FloatObjectField.js